const read = (value: string | undefined): string => value?.trim() ?? ''

/** Переменные окружения, прочитанные один раз. Сырой `import.meta.env` в коде не используется. */
export const ENV = {
  API_BASE_URL: read(import.meta.env.VITE_API_BASE_URL) || '/api',
  USE_MOCK: read(import.meta.env.VITE_USE_MOCK) === 'true',
  SUPPORT_URL: read(import.meta.env.VITE_SUPPORT_URL),
  MAP_API_KEY: read(import.meta.env.VITE_MAP_API_KEY),
  BOT_USERNAME: read(import.meta.env.VITE_BOT_USERNAME).replace(/^@/, ''),
  /** `false` — Service Worker снимается с устройств (аварийный выключатель, см. PROJECT.md). */
  SERVICE_WORKER: read(import.meta.env.VITE_SERVICE_WORKER) !== 'false',
  IS_DEV: import.meta.env.DEV,
} as const
